import { Route, Redirect } from "react-router-dom";
import React from "react";
import { connect } from "react-redux";
const AuthRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        rest.loggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

const mapStateToProps = (state) => {
  return {
    loggedIn: state.AuthReducer.loggedIn,
  };
};
export default connect(mapStateToProps)(AuthRoute);
